var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlinedUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#05C46B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17C13.5899 17 16.5 14.0899 16.5 10.5C16.5 6.91015 13.5899 4 10 4C6.41015 4 3.5 6.91015 3.5 10.5C3.5 14.0899 6.41015 17 10 17ZM18 10.5C18 14.9183 14.4183 18.5 10 18.5C5.58172 18.5 2 14.9183 2 10.5C2 6.08172 5.58172 2.5 10 2.5C14.4183 2.5 18 6.08172 18 10.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32217 6.86845C9.32983 6.86008 9.33767 6.85189 9.3457 6.84388L9.47082 6.71906C9.76404 6.42651 10.2389 6.42705 10.5315 6.72026L10.6561 6.84518C10.6637 6.85283 10.6712 6.86063 10.6785 6.8686L13.3653 9.80464L13.5303 9.96967C13.8232 10.2626 13.8232 10.7374 13.5303 11.0303C13.2374 11.3232 12.7625 11.3232 12.4697 11.0303L12.2929 10.8536C12.285 10.8457 12.2774 10.8377 12.2699 10.8296L10.7505 9.16916L10.7502 13.7502C10.7501 14.1644 10.4143 14.5001 10.0001 14.5C9.58586 14.4999 9.25015 14.164 9.25024 13.7498L9.25047 9.16844L7.73002 10.8296C7.72256 10.8378 7.71492 10.8457 7.7071 10.8536L7.53033 11.0303C7.23743 11.3232 6.76256 11.3232 6.46967 11.0303C6.17677 10.7374 6.17677 10.2626 6.46967 9.96967L6.63472 9.80462L9.32217 6.86845Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinedUp);
export default __webpack_public_path__ + "static/media/outlined-up.9b4ec7ed.svg";
export { ForwardRef as ReactComponent };